export default {
  "https://www.lyonaeroports.com/informations-pratiques/faq": `Page https://www.lyonaeroports.com/informations-pratiques/faq:
  \`\`\`
  FAQ
  ===
  
   Toutes les réponses à vos questions
   
  
  ![FAQ](https://aeroports-de-lyon.imgix.net/sites/default/files/2023-07/aeroport_de_lyon_faq.jpg?fit=max&ixlib=php-3.3.1&w=900&s=e4abca8c517d0fa6d40960fc8fcc3db3)
   Rechercher Aéroport de Lyon est à votre écoute !
  -------------------------------------
  
  En quelques clics, trouvez toutes les réponses à vos interrogations.  
    
  
  Bagages, accès, parkings, transports entre Lyon et l'aéroport, commerces, services, connexion internet... retrouvez toutes les réponses à vos questions sur les différents services disponibles à l'aéroport de Lyon.
  
   Questions fréquentes
  ----------------------
  
   Les questions les plus souvent posées
   
   
  
  [### 
   Bagage perdu ou endommagé ?](#bagage-perdu-ou-endommag-)Pas de panique, le service bagage est là pour vous
  --------------------------------------------------
  
  **Pour votre information, le traitement des bagages et service bagage sont de l’entière responsabilité de la compagnie aérienne ou de son assistant. Le service client de Lyon Aéroport n’est donc pas en mesure de répondre à vos demandes et suivis de dossier liés aux bagages, et vous invite à vous adresser exclusivement aux sites Internet de votre compagnie ou aux coordonnées indiquées sur [cette page](https://www.lyonaeroports.com/services/bagage-perdu-ou-endommage).**
  
  Vous ne retrouvez pas votre bagage? Ou alors celui-ci est endommagé? 
  
  Le service bagage va tout mettre en œuvre pour localiser votre bagage manquant. Retrouvez ci-dessus la liste des différents services bagages, qu’il s’agisse de votre compagnie aérienne ou d’assistants en escale. Le service bagages est là pour prendre en charge et gérer les bagages manquants ou les bagages endommagés/éventrés (selon conditions relatives à chaque compagnie).
  
  Dans tous les cas, il est important d’effectuer **une déclaration** auprès du service bagage ou sur les bornes dédiées **avant** de quitter la zone de livraison bagage, pour obtenir un N° de dossier permettant de lancer les recherches et d’être recontacté.
  
  Pour certaines compagnies, il vous est possible dans les premières 24h après l’arrivée de votre vol d’effectuer cette démarche depuis leur site Internet.
  
  Si vous êtes bien en possession d’un N° de dossier, vous serez alors recontacté rapidement sans autre démarche de votre part (généralement dossier soldé sous 1 à 2 jours., jusqu’à 5 jours).
  
  A défaut, merci de bien vouloir vous **rapprocher de votre compagnie** le plus rapidement possible.
  
  Dans le cas d’un bagage endommagé, la prise en charge du préjudice dépend :
  
  * Du type d’incident survenu sur votre bagage
  * Des règles contractuelles et commerciales propres à chaque compagnie.
  
  Seule la compagnie sera à même d’analyser et de traiter votre demande, à la condition qu’une déclaration ait été effectuée immédiatement après constatation des dommages lors de livraison bagage à l’arrivée de votre vol. Cette déclaration s’effectue auprès du service bagage ou sur les bornes dédiées présents en zone de livraison bagage. Vous obtiendrez alors un N° de dossier vous permettant d’être recontacté.  
    
  Pour connaître tous vos droits en tant que passager aérien, consultez le site : <https://www.ecologie.gouv.fr/politiques/passagers-aeriens>
  
  [### 
   Rejoindre et partir de l'aéroport](#rejoindre-et-partir-de-laroport)À seulement 25 km du centre-ville, l’aéroport Lyon Saint-Exupéry (LYS) est un lieu multimodal desservi par les transports en commun, et bénéficie d’une solide desserte par le réseau routier et autoroutier, notamment grâce à l’A432.
  
  Navette express, bus, taxi, autopartage, voiture personnelle ou louée, deux-roues… Découvrez [ici](https://www.lyonaeroports.com/acces-transports/liaisons-aeroport-centre-ville) les différentes solutions à votre disposition pour rejoindre l’aéroport Lyon Saint-Exupéry depuis le centre-ville, et arrivez à l’heure pour votre embarquement, ou pour rejoindre facilement le centre historique de la capitale des Gaules au terme de votre vol.
  
  [### 
   Quels sont les objets interdits ou non en bagage ?](#quels-sont-les-objets-interdits-ou-non-en-bagage-)Pour connaitre la liste des articles interdits dans les bagages, consultez la liste des objets interdits ou règlementés en avion: [Conseil Bagages: informations pratiques pour boucler vos valises sans stress | Lyon Aéroport (lyonaeroports.com)](https://www.lyonaeroports.com/informations-pratiques/guide-pratique-bagage)
  
  Pour plus d'informations, consultez le site officiel de la DGAC: [Airbag - Direction Générale de l'Aviation Civile (aviation-civile.gouv.fr)](https://airbag.dsac.aviation-civile.gouv.fr/AirBag)
  
  [### 
   Comment faire voyager son enfant seul ? Dans quelles conditions ?](#comment-faire-voyager-son-enfant-seul-dans-quelles-conditions-)Il existe différents moyens permettant à votre enfant mineur de voyager seul, selon son âge:
  
  Le service UM, proposé par ***les compagnies aériennes,*** permet aux mineurs (entre 4 et 12 ans) non accompagnés, de pouvoir voyager non accompagnés. Avec ce service, votre enfant sera entre de bonnes mains. Voyager sera pour lui un jeu … d'enfant! Consultez [ici](https://www.lyonaeroports.com/informations-pratiques/enfant-voyageant-seul) toute l'information sur ce service et contactez votre compagnie aérienne pour plus de renseignements.
  
   
  
  Pour les enfants de plus de 11 ans, **l'Aéroport de Lyon** propose un service complémentaire d'accompagnement personnalisé[Familliz Ado](https://store.lyonaeroports.com/offres-accompagnement-adolescent) : un personnel dédié facilitera le parcours de votre enfant de bout en bout, de l'arrivée ou au départ de l'Aéroport de Lyon.
  
   
  
   
  
   
  
  [### 
   Où me renseigner pour les formalités administratives et les documents obligatoires ?](#o-me-renseigner-pour-les-formalits-administratives-et-les-documents-obligatoires-)Pour toutes les questions relatives aux pièces d'identité, documents, visa nécessaires lors de votre voyage, nous vous invitions à consulter [le guide pratique](https://www.lyonaeroports.com/informations-pratiques/guide-pratique-documents) de l'Aéroport de Lyon, ainsi que le site officiel du Gouvernement:
  
  [Formalités administratives - Ministère de l’Europe et des Affaires étrangères (diplomatie.gouv.fr)](https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/informations-pratiques/preparer-son-depart/formalites-administratives/)
  
  et par destination:
  
  [Conseils par pays/destination - Ministère de l’Europe et des Affaires étrangères (diplomatie.gouv.fr)](https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays-destination/)
  
  [### 
   J’ai perdu/trouvé un objet à l’aéroport, comment procéder ?](#jai-perdutrouv-un-objet-laroport-comment-procder-)Vous avez perdu un objet à l'Aéroport de Lyon ? Il vous suffit de déposer votre annonce afin d'établir une correspondance!
  
    
  - Rendez-vous sur le site <http://lyonaeroports.franceobjetstrouves.fr/>pour saisir votre annonce.
  
  - Créez un compte en cliquant sur "Inscrivez-vous" en haut à droite de la page ;  
  - Cliquez sur "J'ai perdu un objet" ;  
  - Recherchez la catégorie à laquelle pourrait appartenir l'objet que vous avez perdu et remplissez les caractéristiques demandées ;  
  - Vérifiez, puis Publiez votre annonce ;  
  - Si les résultats présentés ne sont pas satisfaisants, cliquez sur "Plus de résultats" pour élargir votre recherche.  
     
  Lorsque votre descriptif matchera avec un objet trouvé, vous serez mis en contact et la procédure de réconciliation vous sera proposée.
  
  A noter que ce service est payant pour compenser les frais de gestion inhérents à ce service.
  
   
  
  Pour + d'infos: [Objets trouvés Aéroport Lyon | Lyon Aéroport (lyonaeroports.com)](https://www.lyonaeroports.com/services/objets-trouves)
  
  [### 
   PHMR | Puis-je bénéficier d’un service d’accompagnement PMR ?](#phmr-puis-je-bnficier-dun-service-daccompagnement-pmr-)Les PMR doivent informer leur compagnie aérienne de la nécessité d’une assistance PMR au moment de leur réservation ou au moins 48H avant. L’aéroport de Lyon met également à disposition et à titre gratuit des fauteuils roulants, sous réserve de disponibilité (contre présentation d’un document d’identité).
  
  Pour plus de renseignements, rendez-vous sur [la page dédiée](https://www.lyonaeroports.com/informations-pratiques/passagers-mobilite-reduite) de notre site.
  
   
  
  [### 
   Parking | Comment modifier ma réservation parking ?](#parking-comment-modifier-ma-rservation-parking-)Pour modifier votre réservation vous devez **vous connecter à votre [compte client](https://store.lyonaeroports.com/customer/account/login/ "Link: https://store.lyonaeroports.com/customer/account/login/")** puis retrouvez votre commande dans Mon compte / Mes Réservations / **Plus de détails** cliquez sur **« Modifier ma commande »** afin de saisir les modifications souhaitées.   
    
  Il est possible de changer voshoraires et dates d’entrée et/ou de sortie, le nom du bénéficiaire, le numéro de plaque d’immatriculation de votre voitureet vos numéros de vols/trains **jusqu'à 1h avant l'heure d'arrivée sur le parking** (indiquée sur votre réservation).
  
  Si votre parking réservé est **le P1** : la modification n'est possible que jusqu'à la veille du jour d'arrivée sur le parking.
  
   
  
  * Si les modifications n’induisent pas de changement tarifaire, validez simplement la saisie. Votre coupon d’accès sera mis à jour avec ces modifications, pensez à vous munir de sa dernière version en le téléchargeant depuis votre compte client
  * Si les modifications entraînent un trop-perçu ou un moins-perçu, validez la commande avec les nouvelles dates et/ou nouveaux horaires. Le paiement de la totalité de la nouvelle commande vous sera demandé (les avantages tarifaires initialement obtenus restent acquis). La commande initiale vous sera remboursée intégralement, simultanément. Vous recevrez un nouveau coupon de réservation, le précédent devenant obsolète.
  * Le choix de vos heures d’arrivée et de départ est important, d’où la nécessité de prévoir des plages horaires pouvant convenir à vos déplacements et toutes vos formalités aéroport d’arrivée et de départ. Vous pourrez, dès lors, venir vous garer quand vous le souhaitez.   
  L'accès au parking ne pourra s'effectuer que 30 minutes au plus tôt avant l'heure prévue d’arrivée au parking (notée sur votre coupon de réservation). **Il est conseillé d’arriver 2h30 avant l’heure de décollage et prévoir 1h après l’atterrissage.**
  * Une tolérance **d'une heure** est appliquée en plus de l'heure de sortie programmée avant de devoir payer un tarif de dépassement (sauf en cas de retard d'avion).
  
   
  
  [### 
   Comment se rendre à l'aéroport de Lyon depuis la gare Lyon Part-Dieu ?](#comment-se-rendre-laroport-de-lyon-depuis-la-gare-lyon-part-dieu-)La navette Rhônexpress relie l'aéroport Lyon Saint Exupéry au centre-ville de Lyon en moins de 30 minutes.  
  Le premier départ est programmé à 4h25 à Part-Dieu, et 5h00 à l'aéroport. Rhônexpress circule toutes les 15 minutes en journée, et toutes les 30 minutes de 4h25 à 6h00 et de 21h00 à minuit.  
  Vous pouvez aussi prendre place à bord de la navette Rhônexpress aux stations de Lyon Part-Dieu, de Vaulx-en-Velin - La Soie et de Meyzieu Z.I.
  
   
  
  Rendez-vous sur notre [page dédiée](https://store.lyonaeroports.com/acces-transports/rhonexpress) pour plus d'informations ou pour réserver vos billets!
  
  [### 
   PHMR | Où demander une chaise roulante à l'aéroport de Lyon ?](#phmr-o-demander-une-chaise-roulante-laroport-de-lyon-)Vous avez des difficultés à vous déplacer ou avez besoin d'une chaise roulante une fois arrivée à l'aéroport ?
  
  Lyon Aéroport met à votre disposition ce [nouveau service](https://www.lyonaeroports.com/actualites/lyon-aeroport-propose-des-chaises-roulantes-en-libre-service) situé au point d'accueil PHMR en zone public du Terminal 1, pour vous faciliter le voyage.
  
  Pour bénéficier du service, vous devez :
  
  - Réserver une assistance auprès de votre compagnie aérienne lors de l'achat de votre billet  
  - Confirmer votre présence à la compagnie dès votre arrivée  
  - Vous présenter au personnel d'accueil PHMR
  
  Puis déplacez-vous librement et en toute autonomie à l'aéroport dès votre arrivée jusqu'à l'embarquement.
  
   Questions et réponses par thématique
  --------------------------------------
  
  [Notre site de réservation en ligne](#category-4198) [Formalités et informations pratiques](#category-4199) [Accès & Parking](#category-4200) [Commerces et services](#category-4201) 
   Notre site de réservation en ligne
  ------------------------------------
  
   Choisissez un sujet
   
  
  [### 
   Réservation Parking](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/reservation-parking "Réservation Parking")[### 
   Comment utiliser le site de réservation en ligne ?](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/comment-utiliser-le-site-de-reservation-en-ligne "Comment utiliser le site de réservation en ligne ?")[### 
   Parking P5+ Automatique](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/parking-p5-automatique "Parking P5+ Automatique ")[### 
   Abonnement Parking](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/abonnement-parking "Abonnement Parking")[### 
   Voiturier](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/voiturier "Voiturier")[### 
   Envoi d'objets interdits](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/envoi-dobjets-interdits "Envoi d'objets interdits")[### 
   Coupe-file](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/coupe-file "Coupe-file")[### 
   Salon](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/salon "Salon")
   Formalités et informations pratiques
  --------------------------------------
  
   Choisissez un sujet
   
  
  [### 
   Enfants mineurs](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/enfants-mineurs "Enfants mineurs")[### 
   Transport d'animaux et de marchandises](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/transport-danimaux-et-de-marchandises "Transport d'animaux et de marchandises")[### 
   Avion & Jet lag](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/avion-jet-lag "Avion & Jet lag")[### 
   Conseils, formalités et documents de voyage](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/conseils-formalites-et-documents-de-voyage "Conseils, formalités et documents de voyage ")[### 
   Bébé](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/bebe "Bébé")[### 
   Questions fréquentes](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/questions-frequentes "Questions fréquentes")
   Accès & Parking
  -----------------
  
   Choisissez un sujet
   
  
  [### 
   Les accès à l'aéroport](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/les-acces-laeroport "Les accès à l'aéroport")[### 
   Nos parkings](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/nos-parkings "Nos parkings")[### 
   Louer un véhicule](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/louer-un-vehicule "Louer un véhicule")
   Commerces et services
  -----------------------
  
   Choisissez un sujet
   
  
  [### 
   Argent, Bureau de change](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/argent-bureau-de-change "Argent, Bureau de change")[### 
   Shopping, Restaurants et Hôtels](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/shopping-restaurants-et-hotels "Shopping, Restaurants et Hôtels")[### 
   Multimédia](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/multimedia "Multimédia")[### 
   Duty-Free](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/duty-free "Duty-Free")[### 
   Safebag & services](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/safebag-services "Safebag & services")[Santé](#category-4202) [Bagages et Effets personnels](#category-4203) [A l'Aéroport](#category-4204) [Passage aux frontières - PARAFE](#category-4205) 
   Santé
  -------
  
   Choisissez un sujet
   
  
  [### 
   Santé](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/sante "Santé")
   Bagages et Effets personnels
  ------------------------------
  
   Choisissez un sujet
   
  
  [### 
   Liquide et alimentation](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/liquide-et-alimentation "Liquide et alimentation")[### 
   Bagage en soute](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/bagage-en-soute "Bagage en soute")[### 
   Bagage à main](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/bagage-main "Bagage à main")[### 
   Articles de toilette](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/articles-de-toilette "Articles de toilette")
   A l'Aéroport
  --------------
  
   Choisissez un sujet
   
  
  [### 
   S'organiser et être à l'heure](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/sorganiser-et-etre-lheure "S'organiser et être à l'heure")[### 
   objets trouvés, emploi et questions pratiques](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/objets-trouves-emploi-et-questions-pratiques "objets trouvés, emploi et questions pratiques")
   Passage aux frontières - PARAFE
  ---------------------------------
  
   Choisissez un sujet
   
  
  [### 
   Contrôle frontière automatisé](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/controle-frontiere-automatise "Contrôle frontière automatisé")[PHMR](#category-4206) [Biometric Experience](#category-4729) [MONA](#category-4761) 
   PHMR
  ------
  
   Choisissez un sujet
   
  
  [### 
   En quoi consiste la demande d'assistance ?](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/en-quoi-consiste-la-demande-dassistance "En quoi consiste la demande d'assistance ?")[### 
   Bien préparer ma demande d'assistance](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/bien-preparer-ma-demande-dassistance "Bien préparer ma demande d'assistance")
   Biometric Experience
  ----------------------
  
   Choisissez un sujet
   
  
  [### 
   Qu’est-ce que la Biometric Experience ?](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/quest-ce-que-la-biometric-experience "Qu’est-ce que la Biometric Experience ?")
   MONA
  ------
  
   Choisissez un sujet
   
  
  [### 
   Qu'est ce que MONA ?](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/quest-ce-que-mona "Qu'est ce que MONA ?")[### 
   MONA et la Biometric Experience](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/mona-et-la-biometric-experience "MONA et la Biometric Experience")
   Contactez-nous
  ----------------
  
   Nous sommes à votre écoute
   
   
  
  [### 
   Par chatbot
  
   Obtenez une aide instantanée](#)[### 
   Par email
  
   Une information, une suggestion, une réclamation ?](https://ecouteclient.lyonaeroports.com/hc/fr/requests/new)[### 
   Par téléphone
  
   Nous sommes ouvert 7j/7 de 8h30 à 16h](#par-tlphone)au 0 826 800 826 (0.15€/min)  
  
   
  
  Nous avertissons nos passagers qu’en raison d’une**forte demande**, des temps d’attente prolongés ou des non-réponses sont actuellement observés.  
  
  Nous rappelons que pour **des questions concernant votre voyage (dossier vol, livraison bagage, formalités sanitaires…)**, il convient de **contacter directement votre compagnie ou agence de voyage**, l’aéroport ne pouvant se substituer à ces renseignements.  
  
  Lyon Aéroport tentera cependant de vous informer et de vous aider au maximum, et vous remercie de votre compréhension.
   
   [### 
   Par courrier](#par-courrier)Aéroports de Lyon B.P. 113 69125 Lyon-Saint Exupéry Aéroport
  
  [### 
   Pour signaler un problème terrain](https://ecouteclient.lyonaeroports.com/hc/fr/requests/new?ticket_form_id=360000123738)
   \`\`\``,
  "https://www.lyonaeroports.com/informations-pratiques/guide-pratique-documents": `Page https://www.lyonaeroports.com/informations-pratiques/guide-pratique-documents:
  \`\`\`
  Documents & formalités
  ========================
  
   Toutes les informations utiles pour voyager en conformité
   
  
  ![Passeport et bagages](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-04/passport-2733068_1920.jpg?fit=max&ixlib=php-3.3.1&w=900&s=d955a653bb789b363c88f136984dd181)* Documents d'identité : votre priorité !
  * Autre documents
  Les documents d'identité
  ------------------------
  
  Impossible de partir sans eux ! Passeport et visas, carte d’identité, même pour les enfants : les oublier c’est dire adieu à votre voyage.  Avec le renforcement des contrôles dans le cadre de l’opération Vigipirate, les vols intérieurs sont également soumis à des contrôles stricts pour la sécurité de tous. Avant votre départ, assurez-vous auprès de votre agence de voyage, tour opérateur ou compagnie aérienne des formalités à accomplir.  
    
  **Gagnez du temps aux contrôles des frontières avec PARAFE\***  
  
  Vous disposez d’un passeport biométrique français ? Vous êtes ressortissant de l’un des 27 états membres de l’union européenne, de la Suisse, de la Norvège, de l’Islande ou du Lichtenstein (espace Schengen) et avez plus de 18 ans ? Optez pour les nouveaux sas à reconnaissance faciale PARAFE et passez les contrôles frontières en un clin d’œil.   
  
     
  *\*Passage Automatisé Rapide des Frontières Extérieures*  
  
    ![guide document drapeau France](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-04/guide_document_france.PNG?fit=max&ixlib=php-3.3.1&w=900&s=32ae1b5dc51476b4dc1e9aa2b3d17820)Je suis français
  ----------------
  
  * **Pour voyager en France**, vous devrez présenter une carte nationale d'identité française, un passeport, ou un permis de conduire. Pour voyager en outre-mer, si vous transitez pas un pays étranger, un passeport vous sera demandé.
  * **Pour voyager dans l'Union Européenne et l'espace Schengen**, vous  devrez présenter une carte nationale d'identité française ou un passeport. Attention: un mineur voyageant sans ses parents doit posséder en plus une autorisation de sortie de territoire signée par l'un de ses parents.
  * **Pour les autres destinations**, vous devrez présenter votre passeport. Pour certains pays,  d'autres documents pourront vous être demandés (visa par exemple).  Renseignez-vous sur la rubrique Conseil aux voyageurs du site du ministère des affaires étrangères.
  
  [Site du ministère des affaires étrangères / Conseil aux voyageurs](https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays-destination/)
  
  [![guide document carte europe](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-04/guide_document_europe.jpg?fit=max&ixlib=php-3.3.1&w=900&s=81de621b86ea9459ac65bfb05d81cc9c)Je suis ressortissant de l'UE
  -----------------------------
  
  * **Pour voyager en France**, vous devrez présenter une carte d’identité ou un passeport. Pour voyager en outre-mer, si vous transitez par un pays étranger, un passeport vous sera demandé.
  * **Pour voyager dans l'Union Européenne et l'espace Schenghen**, vous devrez présenter une carte d’identité ou un passeport. Attention : un mineur voyageant sans ses parents doit posséder une autorisation de sortie du territoire signée par l’un de des parents.
  * **Pour les autres destinations**, vous devrez présenter votre passeport. Pour certains pays,  d'autres documents pourront vous être demandés (visa par exemple).  Renseignez-vous sur la rubrique Conseil aux voyageurs du site du ministère des affaires étrangères.
  
  Conditions d'entrée et de circulation dans l'Espace Schengen](https://www.service-public.fr/particuliers/vosdroits/F1765)![guide document carte monde nuage](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-04/guide_document_monde.jpg?fit=max&ixlib=php-3.3.1&w=900&s=c6ed6c172a000a8ea877a200c19a0f57)Je suis citoyen hors espace Schengen
  ------------------------------------
  
  * **Pour voyager en France**, vous devrez présenter un passeport et votre titre de séjour si vous en avez un. Renseignez-vous sur les visas si vous n’avez pas de titre de séjour délivré par la France ou par un pays de l’Espace Schengen.
  * **Pour voyager dans l'Union Européenne et l'espace Schengen**, vous devrez présenter un passeport et votre titre de séjour si vous en avez un. Renseignez-vous sur les visas si vous n’avez pas de titre de séjour délivré par un pays de l’espace Schengen.
  * **Pour les autres destinations**, vous devrez présenter votre passeport. Certains pays demandent des visas ou d’autres documents. Renseignez-vous sur la rubrique Conseil aux voyageurs du site du Ministère des Affaires étrangères.
  
  [Conditions d'entrée et de circulation dans l'Espace Schengen](https://www.service-public.fr/particuliers/vosdroits/F1765)
  
  ### Pour plus de détails
  
    
  
  Retrouvez la liste détaillée des conditions et documents pour voyager dans le monde.[Conditions d'entrée en France](https://www.service-public.fr/particuliers/vosdroits/N105)[Arrêté du 20 novembre 2015 relatif aux mesures de sûreté de l'aviation civile : article 2](https://www.legifrance.gouv.fr/affichTexteArticle.do?idArticle=JORFARTI000031500978&cidTexte=JORFTEXT000031500964)[Documents et conseils par pays](https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays-destination/)Les autres documents de voyage
  ------------------------------
  
  ![guide document visa voyage](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-04/guide_document_visa.jpg?fit=max&ixlib=php-3.3.1&w=900&s=6cbb87aa259e1dd5bff5ddbef082a858)### Pensez à votre VISA
  
  Certains **pays exigent un visa**, en plus de votre passeport.  
  
  Renseignez-vous auprès de votre agence de voyages, de votre compagnie aérienne ou du consulat de votre pays de destination.
  
  ![guide document carnet vaccination](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-04/guide_document_carnet_vaccination.jpg?fit=max&ixlib=php-3.3.1&w=900&s=ac0187af6916f915eb6fc2b4a33ee8ac)### N'oubliez pas votre carnet de vaccination
  
  Pour partir l’esprit tranquille, pensez à vous renseigner **le plus tôt possible sur les risques sanitaires de votre destination**. Vous trouverez tous les conseils nécessaires
  
  [Voir guide pratique santé](https://www.lyonaeroports.com/informations-pratiques/guide-pratique-sante)### Pour plus de détails
  
  [Documents et conseils par pays](https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays-destination/)[Nos conseils santé par continent](https://www.lyonaeroports.com/informations-pratiques/guide-pratique-sante#content-infos-sante-continents)
   Découvrez aussi
  -----------------
  
   Retrouvez des contenus qui pourraient vous intéresser 
  
  [![Passeport](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-03/passeport.jpg?crop=center%2Ccenter&fit=min&fm=webp&h=190&ixlib=php-3.3.1&w=285&s=547126c8b8a51c8b307badb3c9bb773c)
   Formalités de voyage Covid-19
  -------------------------------
  
   Pass vaccinal obligatoire ? Tests nécessaires ou isolement à prévoir ? Toutes les conditions de voyage en un clic](https://www.lyonaeroports.com/informations-pratiques/formalites-de-voyage-covid-19 "Formalités de voyage Covid-19")[![](https://aeroports-de-lyon.imgix.net/sites/default/files/2022-08/questions_santes_header.jpg?crop=center%2Ccenter&fit=min&fm=webp&h=190&ixlib=php-3.3.1&w=285&s=bcea45eda0512338779ac3211823d2db)
   Guide pratique Santé
  ----------------------
  
   Des conseils concotés avec soin pour voyager serein.](https://www.lyonaeroports.com/informations-pratiques/guide-pratique-sante "Guide pratique Santé")[![partir de lyon guide départ](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-05/guide-dpart-lyon.jpg?crop=center%2Ccenter&fit=min&fm=webp&h=190&ixlib=php-3.3.1&w=285&s=c289cc56db900c0bd846e6cf39703441)
   Préparer son départ
  ---------------------
  
   Pour tout savoir, suivez le guide](https://www.lyonaeroports.com/informations-pratiques/preparer-son-depart "Préparer son départ")[![Travel luggage](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-04/travel-4933158_1920.jpg?crop=center%2Ccenter&fit=min&fm=webp&h=190&ixlib=php-3.3.1&w=285&s=f2140361b237a23bc38a831afe04bfa7)
   Guide pratique Bagages
  ------------------------
  
   Retrouvez toutes les infos utiles pour boucler vos valises sans stress](https://www.lyonaeroports.com/informations-pratiques/guide-pratique-bagage "Guide pratique Bagages")
   \`\`\``,
  "https://www.sigvaris.com/fr-fr/entreprise/innovation": `Page: https://www.sigvaris.com/fr-fr/entreprise/innovation
   \`\`\`
   L’innovation par SIGVARIS GROUP

Chez SIGVARIS GROUP, nous nous engageons à remettre en question les certitudes, à rester en mouvements pour explorer, entreprendre et ouvrir le champ des possibles. Nous imaginons, concevons et développons des solutions médicales pertinentes afin de continuer à améliorer la qualité de vie des patients. Ensemble, nous aidons les individus à se sentir au mieux. Tous les jours.

L’innovation est notre leitmotiv et nos patients sont notre source d’inspiration

Nous nous appuyons sur les connaissances.

Notre approche est fondée sur l’étude approfondie des besoins de nos porteurs : patients et consommateurs. Cette analyse de leur comportement, issue de notre démarche de Design Thinking (design = étude et compréhension des besoins), nous a permis d’être à l’origine des innovations majeures dans l’univers de la compression médicale. Nous identifions aussi les technologies et les circuits de distribution d’avenir pour faire évoluer nos modèles.



Nous travaillons à l’intégration.

La créativité isolée n'est que le début. Nous visons à établir des partenariats durables qui combinent l'expertise existante avec les nouvelles demandes des clients et intègrent les innovations dans les processus en cours.

Nous nous efforçons d’avoir un impact.

Le changement par l'innovation est un catalyseur pour atteindre un résultat durable. Ensemble, nous donnons du sens à notre mission de santé et nous développons la valeur de nos solutions auprès de nos clients qui prescrivent, adaptent, distribuent, portent et vivent avec nos solutions, les produits de SIGVARIS GROUP.


Découvrez nos innovations en images

Collant Maternité

Nous avons conçu et développé avec des femmes enceintes un collant de contention Maternité inédit et parfaitement adapté à leurs besoins. Le collant Maternité suit l’évolution du ventre tout au long de la grossesse grâce à sa ceinture évolutive et offre un soutien ventral adapté. Le dessin particulièrement raffiné de la ceinture apporte une touche de féminité et d’élégance.

Collant Maternité
Chaussette DiabtX 3
Chaussette DiabtX 3

La chaussette DiabtX 3 a été pensée pour la mobilité des patients diabétiques souffrant d’œdèmes. Elle répond notamment aux particularités du pied du patient diabétique*. Son port quotidien permet de réduire les œdèmes**. Efficace et respirante***, elle s’adapte à la morphologie des patients grâce à sa longueur de pointe spécifique et évite les surpressions et les frottements sur les zones de fragilité cutanée.

* La construction du pied en 3 zones (pointe longue couvrant les zones sensibles (pointe sans couture), avant et arrière pied) et le choix d’un fil à faible coefficient de frottement pour la pointe et le talon permettent de réduire les surpressions et les frottements. Système de taillage 3 hauteurs & 3 pointures sur la base de l’analyse des données anthropométriques IFTH 2012.

**Conception validée avec un niveau de pression < à 30 mmHg et maîtrise des compressions par un plan de surveillance spécifique.

*** Indice de perméabilité à la vapeur d’eau (BS 7209) > 81 % Rapport d’essai INTERTEK France 04/2021.

MySigvaris : Délivrer en toute simplicité

MySigvaris est l'application d’aide aux choix, innovante, 100% interactive pour les professionnels de santé. Pour mieux conseiller chacun de leurs patients et pour délivrer simplement et rapidement les produits de compression parfaitement adaptés à leurs besoins et attentes.

MySigvaris : Délivrer en toute simplicité

MySigvaris est l'application d’aide aux choix, innovante, 100% interactive pour les professionnels de santé. Pour mieux conseiller chacun de leurs patients et pour délivrer simplement et rapidement les produits de compression parfaitement adaptés à leurs besoins et attentes.
\`\`\``,
  "https://www.lyonaeroports.com/parkings": `Page: https://www.lyonaeroports.com/parkings (Go on this page to do a simulation of the parking prices)
   \`\`\`Parkings et tarifs
   ====================
   
    Réservez votre parking à l'avance et profitez de nos tarifs réduits !
    
     ![](https://aeroports-de-lyon.imgix.net/sites/default/files/2022-07/parking_recharge_client.jpg?fit=max&ixlib=php-3.3.1&w=900&s=99660935f110af4c7a86f5812cdb6071)* Dépose rapide
   * Avantages
   * Bien choisir son parking
   * Tarif & plan des parkings
   * FAQ
   * Navette P5
   * Dépose rapide
   * Motos
   * Promo Ulys
   * Vidéo
   Parkings officiels de l'aéroport de Lyon
   ----------------------------------------
   
   Choisissez les parkings officiels de Lyon Saint-Exupéry : **proches des terminaux**, conformes à la réglementation en vigueur, clos et sécurisés, ils vous apportent **sécurité et confort** pour un voyage **en toute sérénité**. Avec plus de 10 parkings différents à proximité immédiate de nos terminaux, vous trouverez forcément celui qui vous correspond !
   
   Réservez votre stationnement en ligne pour profiter de tous nos avantages : des **tarifs réduits**, une place assurée à votre arrivée, un accès rapide au parking de votre choix grâce à la lecture automatique de votre plaque, et une annulation ou une modification possible jusqu’à 1h00 avant votre arrivée !
   
   Pour votre voyage depuis l'aéroport de Lyon, privilégiez la simplicité et la sérénité, et optez pour la solution la plus sûre : les parkings officiels de Lyon Aéroport ! Voyagez en toute tranquillité au meilleur prix, **à partir de 40€ la semaine seulement.**
   
   ![Amis voitures parking vacances](https://aeroports-de-lyon.imgix.net/sites/default/files/2023-06/amis-voitures-parking.jpg?fit=max&ixlib=php-3.3.1&w=900&s=e1b9c51a28c39e82d64c502e098e0cef)Jusqu'à -50% sur votre parking avec la réservation en ligne !
   -------------------------------------------------------------
   
   Vous venez d'acheter votre billet d'avion ? N'attendez pas et réservez **le plus tôt possible** votre place de parking à Lyon Aéroport pour faire des économies et éviter les mauvaises surprises. Profitez de tarifs exclusifs, **payez moins cher** et arrivez l’esprit serein avec une **place de parking garantie** à votre arrivée.
   
   En optant pour les **parkings officiels** de Lyon Aéroport, vous bénéficiez de zones de stationnement **closes et sécurisées**, d’une excellente qualité de service, d’un **accès rapide et sécurisé aux terminaux** de l’aéroport, de tarifs transparents et sans mauvaise surprise.
   
   [Je réserve mon parking](https://store.lyonaeroports.com/)
   
   4 (très) bonnes raisons de réserver son parking en ligne
   --------------------------------------------------------
   
   1### Votre stationnement a un **tarif exclusif**
   
   Profitez des réductions toute l’année grâce à la réservation en ligne, et préservez votre budget.
   
   2### Votre **place garantie** dans nos parkings
   
   Planifiez votre réservation jusqu’à 9 mois à l’avance, et évitez le stress d’un parking plein à votre arrivée à l’aéroport.
   
   3### Modifiez ou annulez votre réservation **sans frais**
   
   Vos projets changent ? Modifiez ou annulez en ligne votre réservation jusqu’à 1h avant votre arrivée.
   
   4### Aucun supplément en cas de retard de vol
   
   Votre vol est retardé ? Nous prenons à notre charge le surcoût du stationnement.\*   
   *\*Hors P1. Détail dans nos CGV*
   
   [D’autres avantages à retrouver ici](https://store.lyonaeroports.com/pourquoi-reserver-mon-parking)Bien choisir son parking
   ------------------------
   
   Trouver facilement et rapidement le meilleur stationnement est la promesse d’un voyage en avion réussi. Découvrez toutes les indications pour chacun de nos parkings, et prenez un bon départ. Tous nos parkings sont clos et sécurisés. Situés à quelques minutes à pied ou en navette gratuite de l’aéroport et de la gare TGV Lyon-Saint Exupéry, ils vous font gagner un temps précieux à votre arrivée.
   
   Vous recherchez le parking le plus économique ou le plus pratique ? Vous souhaitez retrouver votre véhicule électrique avec une charge pleine à votre retour ? Vous préférez que votre voiture soit dans un parking couvert ? Choisissez le stationnement qui vous convient parmi nos 11 parkings officiels !
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p0.png)**Parking couvert,**  
   situé sous les terminaux 1 & 2
   
   * Hauteur limitée à 1,90 m
   * Service de surveillance 24h/24 et 7j/7
   * Disponible à la réservation
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/informations-parking-zero)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p1.png)**Parking couvert,**  
   situé au pied du terminal 1
   
   * Parking exploité par la Société Lyon Park Auto (LPA)
   * Hauteur limitée à 1,90 m Service de surveillance 24h/24 et 7j/7
   * Disponible à la réservation en ligne
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/informations-parking-un)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p2.png)**Parking extérieur,**  
   situé en face du terminal 2
   
   * Hauteur limitée à 2,50 m Service de surveillance 24h/24 et 7j/7
   * Disponible à la réservation en ligne
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/informations-parking-deux)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p2-bis.png)**Parking extérieur,**  
   situé en face du Terminal 2
   
   * Parking extérieur de petite taille
   * **Disponible uniquement** à la réservation en ligne
   * Pas de limitation de hauteur
   * Service de surveillance 24h/24 et 7j/7
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/informations-parking-deux-bis)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p3.png?v=2)**Parking couvert,**  
   situé en face du Terminal 1
   
   * Hauteur limitée à 2,10 m  
   Service de surveillance 24h/24 et 7j/7  
   Disponible à la réservation
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/informations-parking-trois)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p3-electrique.png)**Parking couvert,**  
   situé en face du Terminal 1
   
   * 
   * Recharge de véhicule électrique
   * **Disponible uniquement** à la réservation en ligne
   * Hauteur limitée à 2,10 m
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/parking-trois-bornes-electriques)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p4.png)**Parking extérieur,**  
   situé en face de la gare TGV
   
   * Hauteur limitée à 2,50 m Service de surveillance 24h/24 et 7j/7
   * Disponible à la réservation en ligne
   * **Nouveau**: Forfait accompagnant de 2h et 4h
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/informations-parking-quatre)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p4-electrique.png)**Parking avec bornes de recharge électrique,**  
   situé en face de la gare TGV
   
   * Recharge de véhicule électrique
   * **Disponible uniquement** à la réservation en ligne
   * Hauteur limitée à 2,50 m
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/parking-bornes-electriques)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p5.png)**Parking extérieur éloigné**  
   Desservi par navette gratuite
   
   * Hauteur limitée à 2,60 m
   * Accès aux terminaux par navette gratuite
   * Service de surveillance 24h/24 et 7j/7
   * Disponible à la réservation en ligne
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/informations-parking-cinq)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p5-plus.png)**Parking extérieur robotisé,**  
   Situé à deux pas d'un arrêt navette
   
   * Stationnement de 3 jours minimum
   * Accès aux terminaux par navette gratuite
   * Service de surveillance 24h/24 et 7j/7
   * **Disponible uniquement** à la réservation en ligne
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/parking-automatique)
   
   ![](https://www.lyonaeroports.com/themes/adl/assets-src/img/icons-parking-black/p6.png)**Parking économique,**  
   situé à quelques minutes de marche des terminaux
   
   * Parking éloigné
   * Terminaux accessible à pied uniquement.  
   **Disponible uniquement** à la réservation en ligne
   
   [Plus de détails](https://store.lyonaeroports.com/offres-parkings/informations-eco-parking)
   
   Tarifs et plan des parkings de Lyon Aéroport
   --------------------------------------------
   
   Pour connaître les tarifs des parkings **sans réservation**, téléchargez la grille ici :
   
   [Télécharger la grille des tarifs](https://www.lyonaeroports.com/sites/default/files/2023-06/ADL23_TARIFS-PARKING_1600x1200mm_V5.pdf)  
   [Télécharger le plan des parkings](https://www.lyonaeroports.com/sites/default/files/2021-05/plan%20parking-2021.pdf)![Parking tarifs plan](https://aeroports-de-lyon.imgix.net/sites/default/files/2022-07/parking_tarifs_plan.jpg?fit=max&ixlib=php-3.3.1&w=900&s=d2b0c0a1053bfc7ebe8e7dcdde1df36e)![Parking tarifs plan](https://aeroports-de-lyon.imgix.net/sites/default/files/2022-07/parking_tarifs_plan.jpg?fit=max&ixlib=php-3.3.1&w=900&s=d2b0c0a1053bfc7ebe8e7dcdde1df36e)FAQ : réservation parking
   -------------------------
   
   Vous n’avez jamais réservé de parking à Lyon Aéroport ?  
   
   Vous allez voir, c’est très simple !
   
   ### Quel parking à proximité du Terminal 1 ?
   
   Les parkings situés **à proximité du Terminal 1** sont le **P4** et le **P3** (accessibles à pied en quelques minutes) ainsi que le **P1** (situé au cœur du terminal). Un **arrêt navette** est effectué devant le Terminal 1 afin de desservir le **parking P5**. 
   
   ### Quel parking à proximité du Terminal 2 ?
   
   Les parkings **à proximité du Terminal 2** sont le **P0**, le **P1**, le **P2** et le **P2 Bis**. Ces parkings sont **accessibles à pied** en quelques minutes car situés au cœur du terminal. Un **arrêt navette** est effectué devant le Terminal 2 afin de desservir le **parking P5**. 
   
   ### Quel parking à proximité de la gare TGV ?
   
   Les parkings à proximité de la Gare TGV sont le **P4**, le **P3** et le **P2**. 
   
   ### A partir de quand puis-je réserver ma place de parking ?
   
   Vous pouvez réserver votre place de parking dans **un délai de 270 jours et jusqu'à 4h avant votre départ**. **Au-delà de 9 mois**, vous pouvez tout de même faire une recherche parking sur vos dates.
   
   ### Comment modifier ma plaque d'immatriculation ?
   
   **Il vous suffit de modifier votre réservation dans votre espace client.** La saisie de votre plaque d’immatriculation est facultative. Si vous souhaitez venir avec un autre véhicule, ou si vous avez commis une erreur dans la saisie de votre plaque, il vous suffit de vous **connecter à votre compte client**, de visualiser la réservation concernée, de cliquer sur « **Modifier ma réservation** » puis de **modifier le numéro de plaque d’immatriculation avant de valider**. Cette modification peut être effectuée jusqu’à 4h avant l’arrivée prévue sur le parking.
   
   ### Comment réserver une place en ligne ?
   
   Une fois sur le site [store.lyonaeroports.com](https://store.lyonaeroports.com/) : Vous **choisissez votre période** de stationnement puis vous **sélectionnez le parking** que vous souhaitez réserver en cliquant sur le bouton « réserver ». Validez votre commande en cliquant sur le bouton « commander ». Vous pouvez alors créer un compte ou vous connecter avec votre login et mot de passe si vous avez déjà un compte. Après cette étape, vous **choisissez votre moyen de paiement** et cliquez sur « passer la commande » après avoir accepté les conditions générales de vente. Vous saisissez ensuite tous les champs demandés pour régler par carte bancaire. **Vous recevez deux mails** : une confirmation de commande, et un autre vous permettant de télécharger ou d’imprimer votre coupon.
   
   ### Comment trouver mon parking une fois à l’aéroport ?
   
   En arrivant à l’aéroport Lyon Aéroport, vous devez suivre la signalisation. **Votre coupon comporte un plan** vous indiquant la localisation de votre parking. Vous sont également communiquées **les coordonnées GPS de l’entrée** de votre parking.
   
    Pour visualiser les plans, rendez-vous sur cette page :  
   [https://www.lyonaeroports.com/plan-des-parkings](/plan-des-parkings)
   
   ### Puis-je réserver un parking, un coupe-file et un salon en même temps ?
   
   Oui, vous avez la possibilité de réserver tous les services en même temps grâce à votre compte client, mais vous recevez des coupons différents. Attention : vous devez réserver votre place de parking au minimum 8h avant votre arrivée à l’aéroport.
   
    
   
   [D’autres réponses à retrouver ​ici](https://www.lyonaeroports.com/informations-pratiques/faq/sujet/reservation-parking)![accès transporteur navette gratuite](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-06/acces-transporteur-navette.png?fit=max&ixlib=php-3.3.1&w=900&s=97eea94be7d0e95d11bdab2afd0a6b06)Navette gratuite pour rejoindre le parking P5
   ---------------------------------------------
   
   Pour **rejoindre facilement le parking P5** situé à l’extérieur à proximité de la bretelle d'accès, Lyon Aéroport met à votre disposition un service de **navette gratuite**, toutes les 10 à 20 min.  
     
   
   Le P5 est découpé en **4 îlots qui portent des noms pour se repérer facilement** (Agadir/Athènes, Berlin, Calvi/Cancun, Dakar/Dublin). Les noms des arrêts de navettes correspondent à ceux des îlots.
   
   [En savoir plus](https://www.lyonaeroports.com/acces-transports/navette-p5)![parking dépose minute Lyon Aéroport](https://aeroports-de-lyon.imgix.net/sites/default/files/2020-07/parking-depose-minute.jpg?fit=max&ixlib=php-3.3.1&w=900&s=38b200a324f59e5bd91c26f8803497f2)Zone d’attente, dépose rapide, parkings minute
   ----------------------------------------------
   
   Pour venir chercher ceux que vous aimez, utilisez la **zone d'attente gratuite** située aux **entrées de l’aéroport**. C’est gratuit et limité à 1 heure d’arrêt.
   
   **Les parkings “minute”** vous permettent de stationner 10 minutes gratuitement. Vous les trouverez à proximité du T1, T2 et de la gare TGV.  
     
   Le [**forfait accompagnant de 2h et 4h**](https://www.lyonaeroports.com/actualites/forfait-accompagnant-2h-et-4h) est également disponible sur le parking P4 pour vos réservations de courte durée.
   
   [Situer les zones d’attente et parkings minute](https://www.lyonaeroports.com/plan-des-parkings)
   
   ![Deux roues parking](https://aeroports-de-lyon.imgix.net/sites/default/files/2022-08/DeuxRoues_parking.jpg?fit=max&ixlib=php-3.3.1&w=900&s=2236fa1055b95e62034655d8aa985683)Stationnement moto
   ------------------
   
   Le stationnement moto est strictement encadré et est autorisé uniquement sur le **parking P0**. Des places réservées sont disponibles à chaque étage et matérialisées au sol par un marquage jaune et noir. 
    
   
    Le stationnement moto sera facturé sur la base d'un **tarif réduit** (-50% du tarif normal P0). Les prix sont affichés à l'entrée du parking P0 ou disponibles **ci-dessous**.
     
     
   [Prix parking Lyon Aéroport](https://www.lyonaeroports.com/sites/default/files/2023-09/ADL23_TARIFS-PARKING_1600x1200mm_V5.pdf)  
     
   
    Pour les voyageurs fréquents, nous proposons un **abonnement P0 moto à moitié prix**.
     
     
   [Abonnements parking Lyon Aéroport](https://store.lyonaeroports.com/offres-abonnements)Ulys, votre partenaire de route
   -------------------------------
   
   Ne perdez plus de temps aux péages ! Lyon Aéroport et [**Ulys**](https://ulys.vinci-autoroutes.com/) s'associent et vous offrent 12 mois de frais de gestion sur votre abonnement télépéage jusqu'au 31/12/2025, avec le code **VIAIRPORTS** !   
    
   
   [En savoir plus](https://www.lyonaeroports.com/actualites/lyon-aeroport-et-ulys)       [S'abonner](https://abonnement2.vinci-autoroutes.com/?code=EVA3&promo=VIAIRPORTS)
   
   ![Parking tarifs plan](https://aeroports-de-lyon.imgix.net/sites/default/files/2022-07/parking_tarifs_plan.jpg?fit=max&ixlib=php-3.3.1&w=900&s=d2b0c0a1053bfc7ebe8e7dcdde1df36e) 
   
    Pourquoi réserver son parking en ligne ?
   ------------------------------------------
   
   ![Parking P3 actualité ](https://aeroports-de-lyon.imgix.net/sites/default/files/2022-04/parking_P3_actualite.jpg?crop=center%2Ccenter&fit=min&h=300&ixlib=php-3.3.1&w=500&s=896733ebeefb84d8bdcaa6f8c7c055fc)Arrêtés préfectoraux et règlement des parkings
   ----------------------------------------------
   
   Pour connaître les arrêtés préfectoraux et le règlement, téléchargez les grilles ici :  
   
    
   
   [Arrêté Préfectoral de stationnement](https://www.lyonaeroports.com/sites/default/files/2023-02/arrete_prefectoral_stationnement_2022.pdf)[Arrêté Préfectoral de circulation](https://www.lyonaeroports.com/sites/default/files/2023-02/arrete_prefectoral_circulation_2022.pdf)[Le règlement des parkings](https://www.lyonaeroports.com/sites/default/files/2021-12/Reglement_des_Parkings_2021_0.pdf)
   \`\`\``,
};
